export default __webpack_public_path__ + "static/media/player_3_1.d7df95de.png";